import type { CSSProperties, PropsWithChildren } from 'react';
import { Text } from '@frameio/vapor';
import styles from './ProjectSettingsSection.module.css';

type ProjectSettingsSectionProps = {
  /** Section heading displayed above the children */
  title?: string;
  /** Optional inline styles applied to the outer container */
  style?: CSSProperties;
};

/** Reusable section wrapper that renders a title label above its children. */
export const ProjectSettingsSection = ({
  title,
  children,
  style,
}: PropsWithChildren<ProjectSettingsSectionProps>) => (
  <div className={styles.section} style={style}>
    {title && (
      <Text color="secondary" truncate={true} variant="secondary">
        {title}
      </Text>
    )}
    <div>{children}</div>
  </div>
);
